module.exports = new __parcel__URL__("xray.4a45f47c.png").toString();